// src/store.js

import { configureStore } from "@reduxjs/toolkit";
import thumbnailReducer from "./redux/slices/ThumbnailSlice";
import exportStoreReducer from "./redux/slices/ExportStoreSlice";
import variationReducer from "./redux/slices/variationSlice";
import planDetailReducer from "./redux/slices/PlanDetailSlice";
import sizeReducer from "./redux/slices/SizeSlice";
import polotnoReducer from "./redux/slices/PolotnoSlice";
import toastReducer from "./redux/slices/ToastSlice";
import userReducer from "./redux/slices/UserSlice";
import designReducer from "./redux/slices/DesignSlice";

const store = configureStore({
  reducer: {
    // counter: counterReducer,
    thumbnails: thumbnailReducer,
    exportStore: exportStoreReducer,
    variation: variationReducer,
    userPlan: planDetailReducer,
    sizeDimension: sizeReducer,
    polotno: polotnoReducer,
    toastMessage: toastReducer,
    user: userReducer,
    design: designReducer,
  },
});

export default store;
